import React, {useEffect} from "preact/compat";

export interface PromotionalBannerProps {
  setActiveMember: () => void;
  isFreemium: boolean;
  isAdmin: boolean;
}

export default function PromotionalBanner({setActiveMember, isFreemium, isAdmin}: PromotionalBannerProps) {
  useEffect(() => {
    if (!isFreemium) {
      $(document).ready(function() {
        $("head").append(`<style id="promo-css-rules" type="text/css">
          body nav.main-nav {
            top: 80px !important;
          }
          .context-bar {
            top: 80px !important;
          }
          #canvas {
            margin-top: 125px !important;
          }
          .right-menu {
            margin-top: -50px !important;
          }
          header.main {
            top: ${isAdmin ? '24px' : '0px'} !important;
          }
          aside.main {
            top: ${isAdmin ? '104px' : '80px'} !important;
          }
        </style>`);
        /*$('body nav.main-nav').css({'top': '80px'});
        $('.context-bar').css({'top': '80px'});
        $('#canvas').css({'margin-top': '125px'});
        $('.right-menu').css({'margin-top': '-50px'});
        $('header.main').css({'top': isAdmin ? '24px' : '0px'});
        $('aside.main').css({'top': isAdmin ? '104px' : '80px'});
        $('aside.main.right').css({'top': isAdmin ? '104px' : '80px'});*/
      });
    }
  }, [isFreemium]);

  function showUpgradeModal() {
    // @ts-ignore
    window.MHM.ProModal.upgrade({memberId: window.data.member.id, onSuccess: setActiveMember});
  }

  return !isFreemium ? '' : <div className={`promotional-banner`} onClick={() => showUpgradeModal()}>
    <p>
      Time for a fall refresh. Save 30% on Pro today! <span className={'prom-upgrade-link'}>Upgrade now</span>
    </p>
  </div>;
}
